import { AILoader } from './AILoader.js'

window.customElements.define('ai-loader', AILoader)
